import {
  ACCOUNT_TYPE_COMPANY,
  ACCOUNT_TYPE_PERSONA,
  resolveAccountType,
} from "../container/Onboarding/registrationShared";

/** sessionStorage flag: user must complete pricing before using the app. */
export const REQUIRE_PRICING_KEY = "requirePricingSelection";

/** Persona vs Company from registration Fill Content — drives Recommended plan. */
export const ONBOARDING_ACCOUNT_TYPE_KEY = "onboardingAccountType";

export const PLAN_ID_PROFESSIONAL = "professional";
export const PLAN_ID_ORGANIZATION = "organization";
export const PLAN_ID_ENTERPRISE = "enterprise";

/**
 * Persist that pricing selection is required after onboarding finishes.
 */
export const persistPricingRequirement = (registration = {}) => {
  const accountType = resolveAccountType(registration);
  sessionStorage.setItem(REQUIRE_PRICING_KEY, "1");
  sessionStorage.setItem(ONBOARDING_ACCOUNT_TYPE_KEY, accountType);
  return accountType;
};

export const isPricingSelectionRequired = () =>
  sessionStorage.getItem(REQUIRE_PRICING_KEY) === "1";

export const getOnboardingAccountType = () => {
  const stored = sessionStorage.getItem(ONBOARDING_ACCOUNT_TYPE_KEY);
  if (stored === ACCOUNT_TYPE_PERSONA || stored === ACCOUNT_TYPE_COMPANY) {
    return stored;
  }
  return ACCOUNT_TYPE_PERSONA;
};

export const clearPricingRequirement = () => {
  sessionStorage.removeItem(REQUIRE_PRICING_KEY);
  sessionStorage.removeItem(ONBOARDING_ACCOUNT_TYPE_KEY);
};

/** Persona → Professional, Company → Organization */
export const getRecommendedPlanId = (accountType) =>
  accountType === ACCOUNT_TYPE_COMPANY
    ? PLAN_ID_ORGANIZATION
    : PLAN_ID_PROFESSIONAL;
